import { Plant } from "../generator/model";
import React from "react";
import _ from "lodash";
import { useCookies } from "react-cookie";

export type Recipe = Plant[];

export const getRecipeHash = (plants: Recipe) =>
  plants
    .map((plant) => plant.id)
    .sort()
    .join(";");

export const usePinnedRecipees = () => {
  const [cookie, setCookie, removeCookie] = useCookies(["pinnedRecipees"]);
  if (!cookie.pinnedRecipees) {
    setCookie("pinnedRecipees", {});
  }

  const pinnedRecipeesMap: Record<string, Recipe> = cookie.pinnedRecipees ?? [];
  const pinnedRecipes = React.useMemo(
    () => Object.values(pinnedRecipeesMap),
    [pinnedRecipeesMap]
  );

  return {
    get: () => pinnedRecipes,
    pinRecpie: (plants: Recipe) => {
      const hash = getRecipeHash(plants);

      if (!pinnedRecipeesMap[hash]) {
        setCookie("pinnedRecipees", { ...pinnedRecipeesMap, [hash]: plants });
      }
    },
    unpinRecipe: (plants: Recipe) => {
      const hash = getRecipeHash(plants);
      const copy = { ...pinnedRecipeesMap };
      delete copy[hash];
      setCookie("pinnedRecipees", copy);
    },
    clear: () => {
      removeCookie("pinnedRecipees");
    },
  };
};
